module.exports = "/static/assets/e35418134f3ccf0992dae078ad213084.png";